import { StyleSheet, ViewProps } from 'react-native'
import { useCompany } from 'zens-store'

import { InfoBlock } from '../info'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
}

const HomeCompany = (props: Props) => {
  const { companyId, style, ...otherProps } = props
  const company = useCompany({ companyId })

  return <InfoBlock title={company.data?.name} style={[styles.container, style]} {...otherProps} />
}

export default HomeCompany
